<template>
  <section class="d-flex">
    <div class="m-auto p-3">
      <ul>
        <li>
          <div class="pt">Contabilidade</div>
          <div class="en">Accountant Service</div>
        </li>
        <li>
          <div class="pt">Consultoria Fiscal</div>
          <div class="en">Tax Consultancy</div>
        </li>
        <li>
          <div class="pt">Apoio à gestão</div>
          <div class="en">Management support</div>

        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  name: "Entrada",
  metaInfo: {
    title: 'Entrada',
  },
  mounted() {
    this.$parent.image = '/images/bg_home.jpg';
  }
}
</script>

<style lang="scss" scoped>
div.m-auto {
  margin: auto;
  text-transform: uppercase;
  font-family: Avenir, serif !important;

  > p {
    text-transform: uppercase;
    font-size: calc(1.5vw + 5px);
    line-height: calc(1.5vw + 5px);
    font-family: Avenir, serif;
  }

  > ul {
    padding: 0;
    font-size: 2vw;
    line-height: 2vw;
    margin: 0;
    font-family: Avenir, serif;
    font-weight: bold;
    user-select: none;
    white-space: nowrap;
  }

  > ul > li {
    display: inline-block;
    list-style-type: circle;
    padding: 0 15px;
    font-family: Avenir, serif;
    height: 2vw;

    div.pt {
      display: inline-block;
      transition: all .5s ease;
    }

    div.en {
      display: inline-block;
      transition: all .5s ease;
      font-size: 0;
      line-height: 0;
    }

    &:hover {
      div.pt {
        font-size: 0;
        line-height: 0;
      }
      div.en {
        font-size: inherit;
        line-height: inherit;
      }
    }

  }

  > ul > li:before {
    content: '\2022';
    margin-right: 0.5em;
    color: lightblue;
  }

  @media screen and (min-width: 775px) {
    > ul > li:first-child {
      padding-left: 0;
    }
    > ul > li:first-child:before {
      content: '';
      margin: 0;
      padding: 0;
    }
  }

  @media screen and (max-width: 774px) {
    > ul {
      font-size: calc(4vw + 10px);
      line-height: calc(4vw + 10px);
      margin: 0;
    }
    > ul > li {
      display: block;
      height: calc(4vw + 10px);
    }
    > p {
      margin-top: 35px;
    }
  }
}
</style>